export default __webpack_public_path__ + "static/media/germanBooksAbc.8f89019b.png";